import React from 'react';
import { usePlannerTranslations } from '../Planner/Context/PlannerTranslationsContextProvider';
import { MessageBroker } from '~/Features/Messaging/MessageBroker';
import { Button } from '~/Partials/Button/Button';
import { SummaryFocus } from './Events/SummaryFocus';
import styles from './SummaryFocusManager.module.css';

export const SummaryFocusManager: React.FC = () => {
    const { actions } = usePlannerTranslations();
    const { goToSummary } = actions;
    const handleButtonClick = () => {
        MessageBroker.publish(SummaryFocus);
    };

    return (
        <Button className={styles.SummaryFocusManager} onClick={handleButtonClick}>
            {goToSummary}
        </Button>
    );
};
